import React from 'react';
import { IProps } from './types';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { setProductExplainModalVisibleAction } from 'redux/actions/modal.action';
import { RootReducersState } from 'redux/reducers';
import Modal from 'components/Modal';

const ProductExplainModal: React.FC<IProps> = (props) => {
  const handleClose = () => {
    props.setProductExplainVisible(false);
  };

  return (
    <>
      {props.modal.productExplainModalVisible && (
        <div className="product-explain-modal">
          <Modal
            visible={props.modal.productExplainModalVisible}
            confirmButton={false}
            onCancel={handleClose}
          >
            <div className="product-explain-modal__example-image" />
          </Modal>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: RootReducersState) => ({
  modal: state.modal
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setProductExplainVisible: (visible: boolean) => dispatch(setProductExplainModalVisibleAction(visible))
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductExplainModal);
